import CApiHelper from '@frontrow/console/src/entities/helpers/common-api-helper'
import {ajaxJsonCall} from '@freckle/ajax'
import {startOperationForm} from '@frontrow/console/src/entities/helpers/operation'
import {pure} from '@freckle/parser'
import {type OperationLocationT} from '@frontrow/console/src/entities/helpers/operation'
import {ContentAreas, type ContentAreaT} from '@frontrow/console/src/entities/helpers/content-area'

export function updateStudentMathLevelsUsingCsvFile(
  districtId: number,
  file: File
): Promise<OperationLocationT> {
  const formData = new FormData()
  formData.append('student-data', file, file.name)

  return startOperationForm(
    'POST',
    `${CApiHelper.fancyPaths.v2.districts.district.district_students.district_students_placements.district_students_placements_content_area._(
      districtId,
      'math'
    )}?asOperation`,
    pure(() => {}),
    formData
  ).then(({operationLocation}) => operationLocation)
}

export async function updateStudentLevelsUsingFastBridgeCsvFile(
  districtId: number,
  contentArea: ContentAreaT,
  file: File,
  scoreColumnName: string,
  overrideRecentPractice: boolean
): Promise<OperationLocationT> {
  const formData = new FormData()
  formData.append('fast-bridge-scores', file, file.name)

  const apiRoute =
    CApiHelper.fancyPaths.v2.districts.district.district_students.district_students_placements.district_students_placements_content_area.fast_bridge(
      districtId,
      contentArea
    )

  return startOperationForm(
    'POST',
    `${apiRoute}?scoreColumn=${scoreColumnName}${overrideRecentPractice ? '&overrideRecentPractice' : ''}`,
    pure(() => {}),
    formData
  ).then(({operationLocation}) => operationLocation)
}

export async function updateStudentLevelsUsingNgmtCsvFile(
  districtId: number,
  file: File,
  overrideRecentPractice: boolean
): Promise<OperationLocationT> {
  const formData = new FormData()
  formData.append('ngmt-scores', file, file.name)

  const apiRoute =
    CApiHelper.fancyPaths.v2.districts.district.district_students.district_students_placements.district_students_placements_content_area.ngmt(
      districtId,
      ContentAreas.math
    )

  return startOperationForm(
    'POST',
    `${apiRoute}${overrideRecentPractice ? '?overrideRecentPractice' : ''}`,
    pure(() => {}),
    formData
  ).then(({operationLocation}) => operationLocation)
}

export async function updateStudentLevelsUsingMAPCsvFile(
  districtId: number,
  contentArea: ContentAreaT,
  file: File,
  overrideRecentPractice: boolean
): Promise<OperationLocationT> {
  const formData = new FormData()
  formData.append('map-scores', file, file.name)

  const apiRoute =
    CApiHelper.fancyPaths.v2.districts.district.district_students.district_students_placements.district_students_placements_content_area.map(
      districtId,
      contentArea
    )

  return startOperationForm(
    'POST',
    `${apiRoute}${overrideRecentPractice ? '?overrideRecentPractice' : ''}`,
    pure(() => {}),
    formData
  ).then(({operationLocation}) => operationLocation)
}

export function updateStudentElaLevelsUsingCsvFile(
  districtId: number,
  file: File
): Promise<OperationLocationT> {
  const formData = new FormData()
  formData.append('reading-levels', file, 'reading-levels')

  return startOperationForm(
    'POST',
    `${CApiHelper.fancyPaths.v2.districts.district.district_students.district_students_placements.district_students_placements_content_area.reading(
      districtId,
      'ela'
    )}?asOperation`,
    pure(() => {}),
    formData
  ).then(({operationLocation}) => operationLocation)
}

export function deleteStudentData(studentId: number): Promise<unknown> {
  return ajaxJsonCall({
    url: CApiHelper.fancyPaths.v2.students._1(studentId),
    method: 'DELETE'
  })
}
